// Shared by availability_controller.js (the existing reservation form) and
// reservation_wizard_controller.js (Step 1 of the dates-first wizard) so the
// two date pickers can't silently drift apart.

export function parseDate(dateString) {
  if (!dateString) return null

  try {
    // ISO date string (YYYY-MM-DD)
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      const [year, month, day] = dateString.split("-").map(Number)
      return new Date(year, month - 1, day)
    }

    // MM/DD/YYYY
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      const [month, day, year] = dateString.split("/").map(Number)
      return new Date(year, month - 1, day)
    }

    return null
  } catch (e) {
    return null
  }
}

// Validates a check-in/check-out pair (as raw input strings). Returns
// { valid: true } or { valid: false, message }. Callers own how the message
// is displayed and whether a submit control gets disabled, since their
// Stimulus targets differ.
export function validateDateRange(startDateString, endDateString) {
  const startDate = parseDate(startDateString)
  const endDate = parseDate(endDateString)
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  if (!startDate || !endDate) {
    return { valid: false, message: "Please enter valid dates in MM/DD/YYYY or YYYY-MM-DD format" }
  }

  if (startDate < today) {
    return { valid: false, message: "Check-in date cannot be in the past" }
  }

  if (endDate < startDate) {
    return { valid: false, message: "Check-out date must be after check-in date" }
  }

  return { valid: true }
}
